import { useRef } from 'react';
import { IconPosition, Size, Type, Variant } from './constants';
import isEnterOrSpacePressed from 'utils/isEnterOrSpacePressed';

import './style.css';

function Button({
  ariaLabel = '',
  children,
  className = '',
  disabled = false,
  icon = '',
  iconPosition = IconPosition.LEFT,
  id = '',
  index = null,
  label = '',
  loading = false,
  loader = '',
  onClick = () => {},
  rightIcon = '',
  size = Size.MEDIUM,
  type = Type.BUTTON,
  tabIndex = 0,
  variant = Variant.PRIMARY,
  ...rest
}) {
  const buttonRef = useRef();

  const disabledClass = disabled || loading ? 'lt-btn-disabled' : '';

  const buttonClassName = `lt-btn lt-btn-${size} lt-btn-${variant} lt-btn-${iconPosition} ${disabledClass} ${className}`;

  function handleClick(event) {
    if (disabled || loading) {
      buttonRef?.current?.blur();
      return;
    }

    onClick(event, { id, index, label });
    buttonRef?.current?.blur();
  }

  function getJSX() {
    const showLoader = loading && !!loader;

    if (children) {
      return (
        <>
          {!!icon && icon}
          {children}
          {!!rightIcon && rightIcon}
          {showLoader && loader}
        </>
      );
    }

    return (
      <>
        {!!icon && icon}
        {label && <span>{label}</span>}
        {!!rightIcon && rightIcon}
        {showLoader && loader}
      </>
    );
  }

  return (
    <button
      aria-label={ariaLabel}
      className={buttonClassName}
      onClick={handleClick}
      onKeyDown={(e) => {
        isEnterOrSpacePressed(e) && handleClick(e);
      }}
      ref={buttonRef}
      tabIndex={tabIndex}
      type={type}
      id={id}
      {...rest}
    >
      {getJSX()}
    </button>
  );
}

Button.IconPosition = IconPosition;
Button.Size = Size;
Button.Variant = Variant;

export default Button;
